
import { Options, prop, Vue } from "vue-class-component";
import ChipsV2 from "@/app/ui/components/chips-v2/index.vue";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { AccountController } from "@/app/ui/controllers/AccountController";

interface SummaryData {
  state: "none" | "suggestion" | "bucket";
  sttCount: number;
  koliCount: number;
  weightKg: number;
  contactName: string;
  contactPhone: string;
  addressLine: string;
  nearestScheduleLabel: string;
  specialHandling: string[];
  showActivePickupCta: boolean;
  activePickupCount: number;
}

class Props {
  summaryData = prop<SummaryData>({
    default: () => ({
      state: "none",
      sttCount: 0,
      koliCount: 0,
      weightKg: 0,
      contactName: "",
      contactPhone: "",
      addressLine: "",
      nearestScheduleLabel: "",
      specialHandling: [],
      showActivePickupCta: false,
      activePickupCount: 0
    }),
    type: Object
  });
  showChangeAddress = prop<boolean>({
    default: false,
    type: Boolean
  });
  showPickupCta = prop<boolean>({
    default: true,
    type: Boolean
  });
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });
  fromListBooking = prop<boolean>({
    default: false,
    type: Boolean
  });
  isInternalAccount = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    ChipsV2,
    LpButton
  },
  emits: [
    "request-pickup",
    "ubah-alamat",
    "lihat-stt",
    "lihat-pickup-aktif",
    "buat-pickup-manual"
  ]
})
class PickupBookingSummary extends Vue.with(Props) {
  get validationAccount(): boolean {
    return AccountController.validationAccount;
  }

  get isSttCorporate(): boolean {
    return ShipmentBookingController.isSttCorporate;
  }

  get summaryDate() {
    const date = new Date(
      this.summaryData.nearestScheduleLabel.replace(" ", "T")
    );
    const locale = this.$i18n.locale === "id" ? "id-ID" : "en-GB";

    const formattedDate = new Intl.DateTimeFormat(locale, {
      weekday: "long",
      day: "numeric",
      month: "long"
    }).format(date);

    const formattedTime = new Intl.DateTimeFormat(locale, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    })
      .format(date)
      .replace(":", ".");

    const [hourStr, minute] = formattedTime.split(".");
    const hour = parseInt(hourStr, 10);
    const addedTime =
      hour === 23
        ? "23.59"
        : `${hour + 1 < 10 ? `0${hour + 1}` : hour + 1}.${minute}`;
    const time = `${formattedTime} - ${addedTime}`;
    return {
      date: formattedDate,
      time: time
    };
  }

  get isEmptyFromListBooking() {
    return (
      (this.summaryData.state === "none" ||
        this.summaryData.state === "suggestion") &&
      this.fromListBooking
    );
  }

  get getIsInActive(): boolean {
    return AccountController.accountData.isClientActive;
  }

  mounted() {
    console.log("is inactive : ", this.getIsInActive)
  }
}
export default PickupBookingSummary;
